/**
 * Client-side funnel counters for KOM, Pipeline, and Alert Flow.
 * The counting itself is `computeFunnelCounters` in `src/data/selectors`; this reads the rings for it.
 */

import { getThreatCandidatesAll, getThreatEventsAll } from '../threats';
import { getSecurityEventsAll } from '../security_events';
import { getThreatElementsAll } from '../elements';
import { getRemediations } from '../remediations';
import { getSources } from '../sources';
import { computeFunnelCounters } from '../../data/selectors/funnelCounters';
import { DEFAULT_FUNNEL_WINDOW, type FunnelCounters, type FunnelWindow } from '../../lib/funnel';

export async function getFunnelCounters(
  nowMs = Date.now(),
  window: FunnelWindow = DEFAULT_FUNNEL_WINDOW
): Promise<FunnelCounters> {
  const [candidates, events, threatEvents, elements, remediations, sources] = await Promise.all([
    getThreatCandidatesAll(),
    getSecurityEventsAll(),
    getThreatEventsAll(),
    getThreatElementsAll(),
    getRemediations(),
    getSources(),
  ]);
  return computeFunnelCounters(
    { candidates, events, threatEvents, elements, remediations, sources },
    nowMs,
    window
  );
}
